import styled from "styled-components";
import { Flex, List } from "../../ui";
import { HeaderWrapper } from "../../components/Layout/Header/styled";
import { SCREEN_WIDTH_DESKTOP } from "../../constants/layout";
import promoBack from "../../assets/images/promo/promo-back.png";
export const PageWrapper = styled(Flex) `
  flex-direction: column;
  height: var(--app-height);
  max-height: var(--app-height);
  background: url(${promoBack});
  background-size: 100% 100%;

  [data-hide-on-mobile] {
    display: initial;
  }

  [data-show-on-mobile] {
    display: none;
  }

  @media screen and (max-width: ${SCREEN_WIDTH_DESKTOP}px) {
    [data-hide-on-mobile] {
      display: none;
    }

    [data-show-on-mobile] {
      display: initial;
    }
  }

  ${HeaderWrapper} {
    background: none;
  }
`;
export const PromoContents = styled(Flex) `
  flex-direction: column;
  width: 100%;
  max-width: 100rem;
  padding: 0 1.75rem;
  color: #ffffff;
`;
export const PromoCardContainer = styled(Flex) `
  background: #ffffff1a;
  border: 0.0625rem solid #ffffff0d;
  border-radius: 0.5rem;
  padding: 2.5rem 2.25rem 2.5rem 2rem;

  ${List} {
    & > li {
      &:not(:last-child) {
        margin-bottom: 0.5rem;
      }
    }
  }
`;
